'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isYesterday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isYesterday.js
// module id = 255
// module chunks = 1